export default __webpack_public_path__ + "static/media/photo--sm--org-2.3f676c90.jpg";